import { Link } from 'react-router-dom';
import styles from './error.module.scss';
const ErrorPage = () => {
	return (
		<div className={styles.errorPageWrap}>
			<div className={styles.errorPageContent}>
				<h2>Oops!</h2>
				<h4>Page not found</h4>
				<p>The page you are looking might have been removed or it's temporarily unavailable.</p>
				<Link to="/" className="bg-amber-500 text-black px-3 py-2 rounded">
					Go to dashboard
				</Link>
			</div>
		</div>
	);
};

export default ErrorPage;
